import Box from '@zenbusiness/zui/Box';
import { styled } from '@zenbusiness/zui/styles';

import TextareaAutosize from '@mui/material/TextareaAutosize';

const TransactionDescContainerStyle = ({ theme }) => ({
  backgroundColor: theme.palette.background.grey.main,
  padding: '16px 24px',
  borderRadius: '16px',
  border: `1px solid ${theme.palette.border.main}`
});

const TextareaStyle = ({ theme }) => ({
  padding: '20px 16px',
  borderRadius: '16px',
  fontFamily: 'inherit',
  fontSize: '16px',
  border: `1px solid ${theme.palette.fixed.black}`,
  resize: 'none',
  outline: 'none',
  '&:focus': {
    borderColor: theme.palette.fixed.black
  },
  '::placeholder': {
    color: theme.palette.text.secondary
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '20px'
  }
});

export const FieldContainerStyled = styled(Box)(TransactionDescContainerStyle);
export const TextareaStyled = styled(TextareaAutosize)(TextareaStyle);
